/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiPipelineSpec } from './ApiPipelineSpec';
import {
  ApiPipelineSpecFromJSON,
  ApiPipelineSpecFromJSONTyped,
  ApiPipelineSpecToJSON,
  ApiPipelineSpecToJSONTyped,
} from './ApiPipelineSpec';
import type { ApiRunMetric } from './ApiRunMetric';
import {
  ApiRunMetricFromJSON,
  ApiRunMetricFromJSONTyped,
  ApiRunMetricToJSON,
  ApiRunMetricToJSONTyped,
} from './ApiRunMetric';
import type { ApiRunStorageState } from './ApiRunStorageState';
import {
  ApiRunStorageStateFromJSON,
  ApiRunStorageStateFromJSONTyped,
  ApiRunStorageStateToJSON,
  ApiRunStorageStateToJSONTyped,
} from './ApiRunStorageState';
import type { ApiResourceReference } from './ApiResourceReference';
import {
  ApiResourceReferenceFromJSON,
  ApiResourceReferenceFromJSONTyped,
  ApiResourceReferenceToJSON,
  ApiResourceReferenceToJSONTyped,
} from './ApiResourceReference';

/**
 *
 * @export
 * @interface ApiRun
 */
export interface ApiRun {
  /**
   * Output. Unique run ID. Generated by API server.
   * @type {string}
   * @memberof ApiRun
   */
  id?: string;
  /**
   * Required input field. Name provided by user,
   * or auto generated if run is created by scheduled job. Not unique.
   * @type {string}
   * @memberof ApiRun
   */
  name?: string;
  /**
   *
   * @type {ApiRunStorageState}
   * @memberof ApiRun
   */
  storage_state?: ApiRunStorageState;
  /**
   *
   * @type {string}
   * @memberof ApiRun
   */
  description?: string;
  /**
   *
   * @type {ApiPipelineSpec}
   * @memberof ApiRun
   */
  pipeline_spec?: ApiPipelineSpec;
  /**
   * Optional input field. Specify which resource this run belongs to.
   * When creating a run from a particular pipeline version, the pipeline
   * version can be specified here.
   * @type {Array<ApiResourceReference>}
   * @memberof ApiRun
   */
  resource_references?: Array<ApiResourceReference>;
  /**
   * Optional input field. Specify which Kubernetes service account this run uses.
   * @type {string}
   * @memberof ApiRun
   */
  service_account?: string;
  /**
   * Output. The time that the run created.
   * @type {Date}
   * @memberof ApiRun
   */
  created_at?: Date;
  /**
   * Output. When this run is scheduled to run. This could be different from
   * created_at. For example, if a run is from a backfilling job that was
   * supposed to run 2 month ago, the scheduled_at is 2 month ago,
   * v.s. created_at is the current time.
   * @type {Date}
   * @memberof ApiRun
   */
  scheduled_at?: Date;
  /**
   * Output. The time this run is finished.
   * @type {Date}
   * @memberof ApiRun
   */
  finished_at?: Date;
  /**
   *
   * @type {string}
   * @memberof ApiRun
   */
  status?: string;
  /**
   * In case any error happens retrieving a run field, only run ID
   * and the error message is returned. Client has the flexibility of choosing
   * how to handle error. This is especially useful during listing call.
   * @type {string}
   * @memberof ApiRun
   */
  error?: string;
  /**
   * Output. The metrics of the run. The metrics are reported by ReportMetrics
   * API.
   * @type {Array<ApiRunMetric>}
   * @memberof ApiRun
   */
  metrics?: Array<ApiRunMetric>;
}

/**
 * Check if a given object implements the ApiRun interface.
 */
export function instanceOfApiRun(value: object): value is ApiRun {
  return true;
}

export function ApiRunFromJSON(json: any): ApiRun {
  return ApiRunFromJSONTyped(json, false);
}

export function ApiRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiRun {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    storage_state:
      json['storage_state'] == null ? undefined : ApiRunStorageStateFromJSON(json['storage_state']),
    description: json['description'] == null ? undefined : json['description'],
    pipeline_spec:
      json['pipeline_spec'] == null ? undefined : ApiPipelineSpecFromJSON(json['pipeline_spec']),
    resource_references:
      json['resource_references'] == null
        ? undefined
        : (json['resource_references'] as Array<any>).map(ApiResourceReferenceFromJSON),
    service_account: json['service_account'] == null ? undefined : json['service_account'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    scheduled_at: json['scheduled_at'] == null ? undefined : new Date(json['scheduled_at']),
    finished_at: json['finished_at'] == null ? undefined : new Date(json['finished_at']),
    status: json['status'] == null ? undefined : json['status'],
    error: json['error'] == null ? undefined : json['error'],
    metrics:
      json['metrics'] == null
        ? undefined
        : (json['metrics'] as Array<any>).map(ApiRunMetricFromJSON),
  };
}

export function ApiRunToJSON(json: any): ApiRun {
  return ApiRunToJSONTyped(json, false);
}

export function ApiRunToJSONTyped(
  value?: ApiRun | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    name: value['name'],
    storage_state: ApiRunStorageStateToJSON(value['storage_state']),
    description: value['description'],
    pipeline_spec: ApiPipelineSpecToJSON(value['pipeline_spec']),
    resource_references:
      value['resource_references'] == null
        ? undefined
        : (value['resource_references'] as Array<any>).map(ApiResourceReferenceToJSON),
    service_account: value['service_account'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    scheduled_at:
      value['scheduled_at'] == null ? value['scheduled_at'] : value['scheduled_at'].toISOString(),
    finished_at:
      value['finished_at'] == null ? value['finished_at'] : value['finished_at'].toISOString(),
    status: value['status'],
    error: value['error'],
    metrics:
      value['metrics'] == null
        ? undefined
        : (value['metrics'] as Array<any>).map(ApiRunMetricToJSON),
  };
}
